export default "__VITE_ASSET__vJgFoKAY__"